import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { MantineProvider } from '@mantine/core';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <React.StrictMode>
          {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
          <MantineProvider withGlobalStyles withNormalizeCSS>
               <BrowserRouter basename="/">
                    <App />
               </BrowserRouter>
          </MantineProvider>
     </React.StrictMode>,
);
